/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Cricpayz
 */
export class Cricpayz {
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Cricpayz
     */
    merchantId: string;
    /**
     *
     * @type {boolean}
     * @memberof Cricpayz
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Cricpayz
     */
    autoApprove: boolean;
}
